import { render } from "./faq.vue?vue&type=template&id=532fa163"
const script = {}

import "./faq.vue?vue&type=style&index=0&id=532fa163&lang=css"

import exportComponent from "C:\\Users\\home\\Documents\\GitHub\\childu_usersite\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__